/* differ* — the founder gate.

   No OTP, no code field, no code on screen, no backend call. Two ways past
   it, both permanent for this browser:

     1. sign up
     2. say you already have your Founder Code

   Escape and the close control are a third thing entirely: they dismiss the
   overlay for this page view and set no flag, because a modal you cannot
   leave by keyboard is a trap.

   The gate is hidden in the markup and only ever revealed from here, so a
   visitor with JavaScript off reads the page normally. The content sits in
   the DOM underneath either way. */
(function () {
  'use strict';

  /* One flag, one name. Plain meaning: this browser is already in, either
     because it signed up or because it told us it has a number. */
  var FLAG = 'differFounderIn';

  /* Crawlers are not visitors. Googlebot runs JavaScript, so the exemption
     has to happen here rather than relying on the gate being JS-driven, or
     Field Notes gets indexed with an interstitial over it. */
  var BOTS = /bot|crawl|spider|slurp|bingpreview|googlebot|duckduckbot|baiduspider|yandex|facebookexternalhit|embedly|quora link preview|showyoubot|outbrain|pinterest|slackbot|vkshare|w3c_validator|whatsapp|telegrambot|twitterbot|applebot|petalbot|ahrefs|semrush|lighthouse|headlesschrome/i;

  function isCrawler() {
    try {
      return BOTS.test(navigator.userAgent || '');
    } catch (e) {
      return false;
    }
  }

  function isIn() {
    try { return localStorage.getItem(FLAG) === '1'; } catch (e) { return false; }
  }

  function markIn() {
    try { localStorage.setItem(FLAG, '1'); } catch (e) { /* private mode: the gate simply returns next load */ }
  }

  /* 24 Sep, round 3. Everyone sees the gate once per visit, including people
     who signed up or skipped before. A visit is this browser tab session:
     closing the tab or browser starts a new one. Within a visit it does not
     come back on every page, so moving around the site is not a nag. */
  var SEEN = 'differGateSeen';

  function seenThisVisit() {
    try { return sessionStorage.getItem(SEEN) === '1'; } catch (e) { return false; }
  }

  function markSeen() {
    try { sessionStorage.setItem(SEEN, '1'); } catch (e) { /* private mode: shown on each page instead */ }
  }

  function init() {
    /* A successful signup anywhere on the site means this browser is in,
       whether it came through the gate or through the hero form. Shopify
       stamps the receipt on the page it redirects back to, so that is the
       signal, and it is the only thing that counts as "successfully". */
    if (document.querySelector('[data-differ-wl-confirm]')) markIn();

    var gate = document.querySelector('[data-differ-gate]');
    if (!gate) return;

    if (isCrawler() || seenThisVisit()) {
      gate.parentNode.removeChild(gate);
      return;
    }

    var lastFocus = null;
    var delay = parseInt(gate.getAttribute('data-differ-gate-delay'), 10) || 0;

    function focusables() {
      return gate.querySelectorAll('a[href], button, input, [tabindex]:not([tabindex="-1"])');
    }

    function open() {
      if (!gate.hidden) return;
      lastFocus = document.activeElement;
      gate.hidden = false;
      markSeen();
      document.documentElement.classList.add('differ-gate-open');
      var first = gate.querySelector('input[type="email"]') || gate.querySelector('button');
      if (first) first.focus({ preventScroll: true });
    }

    /* Dismiss, not skip. No flag is set, so it returns on the next load. */
    function dismiss() {
      gate.hidden = true;
      document.documentElement.classList.remove('differ-gate-open');
      if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
    }

    /* Skip. This browser has said it is already in, and we take its word. */
    function skip() {
      markIn();
      gate.hidden = true;
      document.documentElement.classList.remove('differ-gate-open');
      if (gate.parentNode) gate.parentNode.removeChild(gate);
    }

    var closeBtn = gate.querySelector('[data-differ-gate-close]');
    if (closeBtn) closeBtn.addEventListener('click', dismiss);

    var skipBtn = gate.querySelector('[data-differ-gate-skip]');
    if (skipBtn) skipBtn.addEventListener('click', skip);

    /* Submitting from inside the gate counts the moment it leaves, so a
       visitor who lands back on a page without a receipt is not asked twice. */
    var form = gate.querySelector('form');
    if (form) form.addEventListener('submit', markIn);

    document.addEventListener('keydown', function (e) {
      if (gate.hidden) return;

      if (e.key === 'Escape' || e.key === 'Esc') {
        dismiss();
        return;
      }

      /* Keep tab inside the dialog while it is open. */
      if (e.key !== 'Tab') return;
      var items = focusables();
      if (!items.length) return;
      var first = items[0];
      var last = items[items.length - 1];
      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    });

    if (delay > 0) {
      /* Field Notes: whichever comes first, the delay or 40% of the page. */
      var fired = false;
      var timer = window.setTimeout(function () { if (!fired) { fired = true; open(); } }, delay * 1000);

      var onScroll = function () {
        var doc = document.documentElement;
        var scrollable = doc.scrollHeight - window.innerHeight;
        if (scrollable <= 0) return;
        if (window.scrollY / scrollable >= 0.4 && !fired) {
          fired = true;
          window.clearTimeout(timer);
          window.removeEventListener('scroll', onScroll);
          open();
        }
      };
      window.addEventListener('scroll', onScroll, { passive: true });
    } else {
      open();
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
